import React, {Component} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {Card} from "@irati/ui/src/Layout"
import {H2} from "@irati/ui/src/Typography"
import Expand from "@irati/ui/src/Expander"
import {DEVELOPMENT, LOCAL} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

import {Container} from "./styled"

interface OptionalProps {
  caught?: any
}
interface Props extends OptionalProps {}

class Oops extends Component<Props> {
  static defaultProps: OptionalProps = {
    caught: null
  }

  componentDidMount() {
    this.openExpander()
  }

  componentDidUpdate() {
    this.openExpander()
  }

  openExpander = () => {
    const {caught} = this.props
    const autoShowFor = [LOCAL, DEVELOPMENT]
    if (caught && autoShowFor.includes(env.ENVIRONMENT_NAME)) {
      this.expander.open()
    }
  }

  render() {
    const {caught} = this.props

    return (
      <Container>
        <Card>
          <H2 large><FormattedMessage id="platform.oops.header.text" /></H2>
          <Expand ref={(c) => { this.expander = c }} title="The tech stuff">
            <pre>
              {caught.stack}
            </pre>
          </Expand>
        </Card>
      </Container>
    )
  }
}

export default Oops
